import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VmeCommonModule } from '../../../vme-common.module';
import { ScheduleSelectorComponent } from '../schedule-selector/schedule-selector.component';
import { TransportModeSelectorComponent } from '../transport-mode-selector/transport-mode-selector.component';
import { TravelSchedulerTask } from '../../../interfaces/travel-scheduler/travel-scheduler-task';
import { VmePipesModule } from '../../../vme-pipes.module';
import { TravelSchedulerService } from '../../../services/travel-scheduler.service';
import { TaskSchedule } from '../../../interfaces/travel-scheduler/task-schedule';
import { TaskCollectionTravelMode } from '../../../enums/task-collection-travel-mode.enum';
import { CarryoverAddressSelectorComponent } from '../carryover-address-selector/carryover-address-selector.component';
import { ValidateCarryoverAddressResponse } from '../../../interfaces/carryover/validate-carryover-address';

@Component({
  selector: 'schedule-task',
  standalone: true,
  imports: [
    CommonModule,
    VmeCommonModule,
    ScheduleSelectorComponent,
    TransportModeSelectorComponent,
    VmePipesModule,
    CarryoverAddressSelectorComponent,
  ],
  templateUrl: './schedule-task.component.html',
  styleUrls: ['./schedule-task.component.css'],
})
export class ScheduleTaskComponent implements OnInit {
  @Output() scheduleSelected = new EventEmitter<TravelSchedulerTask>();
  @Input() taskIndex: number = 0;
  @Input() task!: TravelSchedulerTask;
  @Input() previousTaskDropoffWindow: Date;
  @Input() taskCount: number;
  @Input() isVME: boolean = false;
  @Input() carryoverValidationResult: ValidateCarryoverAddressResponse = null;
  @Input() jobId: number;
  @Input() supplierId: number | null = null;
  @Input() supplierRestrictsCarryover: boolean = false;
  @Input() latestHandBackDateTime: Date | null = null;

  @Output() carryoverValidationResultChange = new EventEmitter<ValidateCarryoverAddressResponse>();
  @Output() handedBack = new EventEmitter<void>();
  @Input() isAlreadyScheduledForToday: boolean = false;

  constructor(private travelSchedulerService: TravelSchedulerService) {}

  ngOnInit(): void {}

  protected handleScheduleSelected(schedule: TaskSchedule) {
    this.task.supplierPickupWindow =
      typeof schedule.selectedPickupWindow == 'string'
        ? new Date(schedule.selectedPickupWindow)
        : schedule.selectedPickupWindow;
    this.task.supplierDropoffWindow =
      typeof schedule.selectedDropoffWindow == 'string'
        ? new Date(schedule.selectedDropoffWindow)
        : schedule.selectedDropoffWindow;
    this.task.isSupplierCarryingover =
      this.task.supplierPickupWindow.getDate() != this.task.supplierDropoffWindow.getDate();
    this.scheduleSelected.emit(this.task);
  }

  /**
   * VME users schedule without a carryover toggle, so they can pick a pickup and dropoff on different days
   * when the task or the supplier is not permitted to carry over. They are warned rather than stopped.
   */
  protected get showCarryoverNotPermittedWarning(): boolean {
    if (!this.isVME || !this.task?.isSupplierCarryingover) {
      return false;
    }

    return this.task.restrictsCarryover || this.supplierRestrictsCarryover;
  }

  protected get carryoverNotPermittedReason(): string {
    if (this.task?.restrictsCarryover && this.supplierRestrictsCarryover) {
      return 'this task and the supplier are not approved for carryovers';
    }

    if (this.task?.restrictsCarryover) {
      return 'this task is not approved for carryovers';
    }

    return 'the supplier is not approved for carryovers';
  }

  protected handleTransportModeSelected(mode: TaskCollectionTravelMode) {
    this.task.supplierTransportModeToPickup = mode;
  }
}
